import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import axiosAuth from "../../axiosAuth";
import { POSITION_APPROVAL_LIMIT } from "../apiRoutes";

interface UseGetPositionApprovalLimitsProps {
  positionId: string;
  year: string;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getPositionApprovalLimits = async (positionId: string, year: string) =>
  await axiosAuth.get(
    `${POSITION_APPROVAL_LIMIT}/by-position/${positionId}/year/${year}`
  );

const useGetPositionApprovalLimits = ({
  positionId,
  year,
  queryParams,
}: UseGetPositionApprovalLimitsProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["position-approver-limits", positionId, year],
    queryFn: () => getPositionApprovalLimits(positionId, year),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    ...queryParams,
  });
};

export default useGetPositionApprovalLimits;
